import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { checkbox1, checkbox2, organizeName, taxId, timeSign, signer, organ1, organ2 },
} = checkout;

const validation = Yup.object().shape({
  [checkbox1.name]: Yup.boolean(),
  [checkbox2.name]: Yup.boolean(),
  [organizeName.name]: Yup.string().required(organizeName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [organ1.name]: Yup.string().required(organ1.errorMsg),
  [organ2.name]: Yup.string().required(organ2.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
